<template>
  <MetricsSummaryWithLoader
    :loading="loading"
    :number-of-summary-skeletons="4"
    totals-label-width="208px"
    :summaries="summaries"
    :project-name="projectName"
    :date-range="dateRange"
  />
</template>

<script setup>
import MetricsSummaryWithLoader from '@/components/insights/Metrics/MetricsSummaryWithLoader.vue';
import { computed } from 'vue';
import { isEmpty } from 'lodash-es';
import { numberWithCommas } from '@/helpers/formatters';
import { useColors } from '@/composables/colors';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tooltips: {
    type: Object,
    default: () => ({}),
  },
  projectName: {
    type: String,
    default: '',
  },
  dateRange: {
    type: Object,
    default: () => ({}),
  },
});

const { brandPrimary } = useColors();

const summaries = computed(() => {
  if (isEmpty(props.data)) return [];

  const {
    total_hires: totalHires,
    offer_acceptance_rate: offerAcceptanceRate,
    median_hire_time_days: timeToHire,
    current_open_offers: currentOpenOffers,
  } = props.data || {};

  const baseSummaries = [
    {
      id: 'number_of_hires',
      tooltipKey: 'hiring-number-of-hires',
      label: 'Number of Hires',
      color: brandPrimary.value,
      value: totalHires ? numberWithCommas(totalHires) : '-',
    },
    {
      id: 'avg_acceptance_rate',
      tooltipKey: 'hiring-offer-acceptance-rate',
      label: 'Offer Acceptance Rate',
      color: brandPrimary.value,
      value: offerAcceptanceRate ? `${offerAcceptanceRate.toFixed(1)}%` : '-',
    },
    {
      id: 'median_hire_time',
      tooltipKey: 'hiring-time-to-hire',
      label: 'Time to Hire',
      color: brandPrimary.value,
      value: timeToHire ? `${numberWithCommas(timeToHire)} day${timeToHire > 1 ? 's' : ''}` : '-',
    },
    {
      id: 'current_open_offers',
      tooltipKey: 'hiring-current-number-of-open-offers',
      label: 'Current Number of Open Offers',
      color: brandPrimary.value,
      value: currentOpenOffers
        ? numberWithCommas(currentOpenOffers)
        : '-',
    },
  ];

  return baseSummaries.map((summary) => {
    const { body_r: html, mode } = props.tooltips?.[summary.tooltipKey] || {};
    return {
      ...summary,
      tooltip: { html, mode, key: summary.tooltipKey },
    };
  });
});
</script>
